import { useEffect, useState } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import { useDispatch } from 'react-redux';
import debounce from 'lodash/debounce';

import { virtualVisitActions } from '../../healthboard/virtual-visit';

const DRAG_TYPE = 'VV_TYPE';
const VIDEO_WIDTH = 244 + 16;
const VIDEO_HEIGHT = 196 + 16;

function getDefaultCoords() {
  const left = window.innerWidth - VIDEO_WIDTH;
  const top = 64 + 16;
  return { left, top };
}

export function useDropVideo() {
  const [coords, setCoords] = useState({ left: 0, top: 64 });

  useEffect(() => {
    const defaultCoords = getDefaultCoords();
    setCoords(defaultCoords);
  }, []);

  useEffect(() => {
    const onResize = debounce(() => {
      const ww = window.innerWidth;
      const wh = window.innerHeight;
      let { left, top } = coords;

      left = ww < left + VIDEO_WIDTH ? ww - VIDEO_WIDTH : left;
      top = wh < top + VIDEO_HEIGHT ? wh - VIDEO_HEIGHT : top;

      if (left !== coords.left || top !== coords.top) {
        setCoords({ top, left });
      }
    }, 500);

    window.addEventListener('resize', onResize);

    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, [coords]);

  const [, drop] = useDrop({
    accept: DRAG_TYPE,
    drop(item, monitor) {
      const delta = monitor.getDifferenceFromInitialOffset();
      const left = Math.round(item.left + delta.x);
      const top = Math.round(item.top + delta.y);
      setCoords({ left, top });
      return undefined;
    },
  });

  return {
    coords,
    drop,
  };
}

export function useDragVideo(coords, collapsed) {
  const dispatch = useDispatch();
  const setDragging = flag => dispatch(virtualVisitActions.setDragging(flag));

  const [{ isDragging }, drag] = useDrag({
    item: { id: 'VV', type: DRAG_TYPE, left: coords.left, top: coords.top },
    canDrag: () => collapsed,
    begin() {
      setDragging(true);
    },
    end() {
      setDragging(false);
    },
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
  });

  return {
    isDragging,
    drag,
  };
}



// WEBPACK FOOTER //
// ./src/redux/opentok/hooks/useDragVideo.js